const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Editor from './edit';
import Save from './save';

registerBlockType('app/tabs-sumicity', {
  title: 'Tabs Sumicity',
  description:
    'Agrupe informações em diferentes guias para controlar os blocos exibidos durante a navegação do usuário por cada uma.',
  icon: 'table-col-after',
  category: 'design',
  attributes,

  edit: (props) => <Editor {...props} />,
  save: (props) => <Save {...props} />,
});
